import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Bus, MessageType } from 'dygc'
import {
  Message,
  TimeSelect,
  Dialog,
  Loading,
  CarouselItem,
  Carousel,
  Header,
  Checkbox,
  Radio,
  Pagination,
  CheckboxGroup,
  RadioGroup,
  Cascader,
  Table,
  TableColumn,
  Progress,
  Button,
  Select,
  Option,
  DatePicker,
  TimePicker,
  Slider,
  Input,
  Image,
  MessageBox,
  Tooltip,
  Empty,
  Form,
  FormItem,
  Drawer
} from 'dygc-ui'
import { overlay } from '@/assets/js/overlay'
import { confirm } from '@/assets/js/confirm'
import scroll from '@/assets/js/scroll'
import 'dygc-ui/lib/theme-chalk/index.css'
import '@/assets/scss/index.scss'

Vue.config.productionTip = false

Vue.use(Drawer)
Vue.use(Header)
Vue.use(CarouselItem)
Vue.use(Carousel)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Cascader)
Vue.use(Pagination)
Vue.use(Image)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Progress)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(TimePicker)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(Slider)
Vue.use(Empty)
Vue.use(Form)
Vue.use(FormItem)
Vue.prototype.$msgbox = MessageBox
Vue.use(Loading.directive)
Vue.use(Bus, {
  loading(text = 'loading') {
    return Loading.service({
      text,
      target: document.body,
      background: 'rgba(0, 0, 0, 0.8)'
    })
  },
  message(type, message, vm) {
    const elementMessageType = {
      [MessageType.SUCCESS]: 'success',
      [MessageType.ERROR]: 'error',
      [MessageType.WARNING]: 'warning'
    }

    if (typeof message === 'string') {
      Message({ type: elementMessageType[type], message })
    } else {
      const h = vm.$createElement
      Message({
        type: elementMessageType[type],
        message: h('div', { attrs: { class: 'el-message__content' } }, [
          h('div', { attrs: { class: 'w-full truncate' } }, message.title),
          h('div', { attrs: { class: 'mt-2' } }, message.message)
        ])
      })
    }
  },
  overlay,
  scroll,
  confirm
})

Vue.prototype.$ELEMENT = {
  size: 'small'
}
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

document.body.ondrop = function (e) {
  // fix 禁止火狐浏览器拖拽打开链接
  e.preventDefault()
  e.stopPropagation()
}
